import React, { Component } from 'react';
import HeaderLocation from '../components/Header';

class BebidasIngredientes extends Component {
  render() {
    return (
      <div>
        <HeaderLocation />
      </div>
    );
  }
}

export default BebidasIngredientes;
